document.addEventListener("DOMContentLoaded", function () {
  $('.slick-slider').slick({
    slidesToShow: 4, 
    slidesToScroll: 1,
    arrows: false, 
    dots: true,
    autoplay: true,
    autoplaySpeed: 2500,
    infinite: true,
    speed: 500,
    responsive: [
       {
        breakpoint: 992,
        settings: {
          slidesToShow: 3, 
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, 
        }
      }
    ]
  });
});
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const accordionItem = header.parentElement;
    const isActive = accordionItem.classList.contains('active');

    // Close all other items
    document.querySelectorAll('.accordion-item').forEach(item => {
      item.classList.remove('active');
    });

    // Toggle the clicked item
    if (!isActive) {
      accordionItem.classList.add('active');
    }
  });
});
